import React from 'react';

import BundleEditView from '@components/shared/bundles/BundleEditView';
import { useMerchant } from '@contexts/admin/MerchantContext';
import { useMerchantData } from '@contexts/admin/MerchantDataContext';

import adminBundleService from '@services/admin/bundleService';
import adminProductService from '@services/admin/productService';

interface InventoryTypeOption {
  id: string;
  name?: string;
  [key: string]: unknown;
}

const AdminBundleEdit: React.FC = () => {
  const { currentMerchant } = useMerchant();
  const merchantData = useMerchantData();
  const inventoryTypes = (merchantData?.inventoryTypes ?? []) as InventoryTypeOption[];

  return (
    <BundleEditView
      bundleService={adminBundleService as any}
      productService={adminProductService as any}
      inventoryTypes={inventoryTypes}
      role="admin"
      // Admin session 鎖單一 merchant；ProductSelect filter 直接吃 currentMerchant
      merchantId={currentMerchant?.id ?? null}
      merchantDataLoading={Boolean(merchantData?.loading)}
    />
  );
};

export default AdminBundleEdit;
